import { FastField } from 'formik'

const EditableTextField = ({
  name,
  placeholder,
  type = 'text',
  variant = 'standard',
  editable = true,
  onEditToggle,
  ...props
}) => {
  const handleToggle = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (onEditToggle) {
      onEditToggle(!editable)
    }
  }

  // Variant-specific styles
  const getInputClassName = () => {
    const baseClasses = 'block w-full focus:outline-none transition-all'

    if (variant === 'bold') {
      // Bold variant: large text, bold, bottom border only when editing
      const editableClasses = editable
        ? 'text-xl font-bold border-0 border-b-2 border-gray-300 focus:border-brandSecondary bg-transparent py-2 pr-20'
        : 'text-xl font-bold border-0 bg-transparent py-2 pr-20'
      return `${baseClasses} ${editableClasses}`
    }

    // Standard variant: regular input styling
    return `${baseClasses} mt-2 rounded-lg border-gray-300 shadow-sm focus:border-brandSecondary focus:ring-brandSecondary pr-20 ${
      editable ? '' : 'bg-gray-50'
    }`
  }

  return (
    <div className="relative">
      <FastField
        type={type}
        name={name}
        placeholder={placeholder}
        className={getInputClassName()}
        readOnly={!editable}
        autoComplete="off"
        data-lpignore="true"
        data-form-type="other"
        {...props}
      />
      <button
        type="button"
        onClick={handleToggle}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-gray-600 hover:text-brandSecondary transition-colors px-2 py-1"
      >
        {editable ? 'Save' : 'Edit'}
      </button>
    </div>
  )
}

export default EditableTextField